<app-header *ngIf="!hideMasterTemplate"></app-header>

<app-side-bar-menu *ngIf="!hideMasterTemplate"></app-side-bar-menu>

<router-outlet></router-outlet>

<app-footer></app-footer>
